
import { Vue } from "vue-class-component";

class Generate extends Vue {}
export default Generate;
